import React, { useState } from 'react';
import Chart from 'react-apexcharts';

export default function BarChart(props) {
    const [state, setState] = useState(
        {
            series: props.series,
            options: {
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                    toolbar: {
                        show: true
                    },
                    zoom: {
                        enabled: true
                    }
                },
                title: {
                    text: props.title,
                    align: 'center'
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 5,
                        dataLabels: {
                            total: {
                                enabled: true,
                                style: {
                                    fontSize: '13px',
                                    fontWeight: 900
                                }
                            }
                        }
                    },
                },
                xaxis: {
                    // type: 'datetime',
                    categories: props.categories_X,
                    title: {
                        text: props.title_X
                    }
                },
                yaxis: {
                    title: {
                        text: props.title_Y
                    }
                },
                legend: {
                    position: 'bottom',
                    offsetY: 10
                },
                fill: {
                    opacity: 1
                },

                tooltip: {
                    custom: ({ series, seriesIndex, dataPointIndex }) => {
                        if (props && props.series && props.series[seriesIndex] && props.series[seriesIndex].job_ids && props.series[seriesIndex].job_ids[dataPointIndex]) {
                            let ind = props?.series[seriesIndex]?.job_ids[dataPointIndex].split(',')
                            let dat = ind.map((each, index) => {
                                return `<div style="padding:1px">${each}</div>`
                            })
                            return `<div style="padding:8px">${dat.join('')}</div>`
                        } else {
                            return ''
                        };
                    },

                }
            },
        }
    )
    return (
        <>
            <Chart
                options={state.options}
                series={state.series}
                type="bar"
                height={320}
            />
        </>
    );
}